export default __webpack_public_path__ + "media/color/zilla-dce6b094.svg";